import { render, staticRenderFns } from "./DeviceMaterial.vue?vue&type=template&id=4120a54c&scoped=true&"
import script from "./DeviceMaterial.vue?vue&type=script&lang=js&"
export * from "./DeviceMaterial.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMaterial.vue?vue&type=style&index=0&id=4120a54c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120a54c",
  null
  
)

export default component.exports